import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'request-tracker',
});

export const detailRouteRef = createSubRouteRef({
  id: 'request-tracker:detail',
  parent: rootRouteRef,
  path: '/detail/:requestId',
});

export const approveRouteRef = createSubRouteRef({
  id: 'request-tracker:approve',
  parent: rootRouteRef,
  path: '/approve',
});
